import styled from 'styled-components';

import { Section } from '@/containers-ai/SectionHeading';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const SectionCustom = styled(Section)`
  border-top: ${(props) =>
    props.border ? `1px solid ${homeColor.carbon}` : `none`};
  padding: ${(props) => (props.border ? `40px 0` : `0`)};

  ${screen.md} {
    padding: ${(props) => (props.border ? `60px 0` : `0`)};
  }

  ${screen.lg} {
    padding: ${(props) => (props.border ? `80px 0` : `0`)};
  }

  ${screen.xxlg} {
    padding: ${(props) => (props.border ? `100px 0` : `0`)};
  }
`;

export const OpsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  align-items: center;
  margin-top: 26px;

  ${screen.lg} {
    grid-template-columns: 1fr 1.05fr;
    gap: 48px;
  }
`;

export const Top100 = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.$single ? '1fr' : 'auto 1fr')};
  gap: 22px;
  align-items: center;
  border: 1px solid ${homeColor.line2};
  border-radius: 16px;
  padding: 22px 26px;
  background: linear-gradient(
    120deg,
    rgba(0, 215, 215, 0.05),
    rgba(20, 214, 77, 0.06)
  );
`;

export const Top100Big = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  ${screen.md} {
    font-size: 34px;
  }

  ${screen.lg} {
    font-size: 43px;
  }
`;

export const Top100Small = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${homeColor.muted2};
  margin-top: 2px;
  line-height: 1.5;
  text-align: center;
`;

export const Top100Copy = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 17px;
  margin: 0;

  b {
    color: ${homeColor.white};
  }
`;
